<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">项目icon列表</h3>
      <div v-if="data">
        <Row class="row" >
          <Col span="4">序号</Col>
          <Col span="6">状态</Col>
          <Col span="12">icon</Col>
        </Row>
        <Row class="row" >
          <Col span="4">1</Col>
          <Col span="6">可签约</Col>
          <Col span="12">

            <img class="imgwidth" v-if="data.projectSignableIcon"  :src="data.projectSignableIcon"/>
            <Upload class="upload"
                    :action="baseUrl+'/file/uploadFile'"
                    :on-success="handleSuccess1"
                    :headers="{'Access-Token':token}"
                    :show-upload-list="false"
                    :on-error="handleError"
            >
              <Icon type="ios-plus-empty" size="40" style="vertical-align: middle"></Icon>
            </Upload>

          </Col>
        </Row>
        <Row class="row" >
          <Col span="4">2</Col>
          <Col span="6">已满房</Col>
          <Col span="12">
            <img class="imgwidth" v-if="data.projectFullIcon"  :src="data.projectFullIcon"/>
            <Upload class="upload"
                    :action="baseUrl+'/file/uploadFile'"
                    :on-success="handleSuccess2"
                    :headers="{'Access-Token':token}"
                    :show-upload-list="false"
                    :on-error="handleError"
            >
              <Icon type="ios-plus-empty" size="40" style="vertical-align: middle"></Icon>
            </Upload>
          </Col>
        </Row>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {getProjectConfigInfo,saveProjectConfigInfo} from "../../../../api/projectConfig";
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";

  export default {
    name: "IconModal",
    props:{
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        this.data=null
        this.getProjectConfigInfo()
        this.isShow=true
      },
    },
    data(){
      return {
        isShow:false,
        data:null,
        loading:true,
        token: '',
        baseUrl: '',
      }
    },
    methods:{
      handleError(){
        // this.$Message.error('图片上传失败')

      },
      handleSuccess1(response){
        this.data.projectSignableIcon = response.data.url
      },
      handleSuccess2(response){
        this.data.projectFullIcon = response.data.url
      },
      getProjectConfigInfo(){
        if(!this.fid){
          return
        }
        var params={
          fid:this.fid
        }
        getProjectConfigInfo(params).then(res=>{
          this.data=res.data
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){
        saveProjectConfigInfo(this.data).then(res=>{
          this.$Message.success('项目icon保存成功')
          this.isShow=false
        })
      },

    },
    created(){
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }

  }
</script>

<style scoped>
  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 50px;

    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

  .imgwidth{
    width: 80px;
    height: 50px;
    vertical-align: middle;
  }
  .upload {
    display: inline-block;
    width: 80px;
    height: 50px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 50px;
    vertical-align: middle;
  }

</style>
